<template>
  <el-dialog class="rc-dialog" title="请假记录" :visible.sync="showDiaInfo.flag" width="400px" top="26vh"
    :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
    <div>
      <div class="tips">该学员已提交请假，请假记录如下：</div>
      <div class="list-content">
        <div class="item" v-for="(item, idx) in dataList" :key="idx">
          <div class="text">开始时间：{{ item.startDayStr || '' }}</div>
          <div class="text">结束时间：{{ item.endDayStr || '' }}</div>
          <div class="text">请假类型：{{ item.leaveTypeName || '' }}</div>
          <div class="text">申请事由：{{ item.auditNotes || '' }}</div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getAuditInfoByAuditUUiids } from '../../../api/studyService';

export default {
  components: {
  },
  props: {
    showDiaInfo: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  data() {
    return {
      dataList: [],
    };
  },
  created() {
    this.getAuditInfo();
  },
  methods: {

    getAuditInfo() {
      getAuditInfoByAuditUUiids({uuids: this.showDiaInfo.uuids}).then(res => {
        if (res.code == 0) {
          this.dataList = res.data || [];
        }
      })
    },
    submit() {
      this.$emit("close");
    },

  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .el-dialog__body {
    padding: 24px 16px 16px;

  }

  .tips {
    font-weight: 500;
    margin-bottom: 16px;
  }

  .list-content {
    .item {
      padding: 16px 0 4px;
      border-bottom: solid 1px #ebeef5;

      .text {
        margin-bottom: 12px;
      }
    }

  }

}
</style>
